// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"230":"bb4b2c77","594":"7401e8c1"}[chunkId] + ".js";
};